import { render, staticRenderFns } from "./ReleaseTrackFormNew.vue?vue&type=template&id=4d6d71cd&"
import script from "./ReleaseTrackFormNew.vue?vue&type=script&lang=js&"
export * from "./ReleaseTrackFormNew.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTrackFormNew.vue?vue&type=style&index=0&id=4d6d71cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports